__turbopack_context__.v({
  "className": "JA4TPG_className",
  "variable": "JA4TPG_variable",
});
